<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('death.Death_from_UBN') }}</h5>
    <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>
    <div class="multisteps-form__content">
      <div class="row mt-3">
        <div class="row mt-3">
          <div class="col-8">
            <div class="input-group input-group-static null" v-if="userRoleName !== 'Keeper'">
                <label>{{ $t('mating.UBN') }} *</label>
                <select id="ubnId" v-model="localFormData.ubnId" class="form-control form-control-default">
                    <option value="">{{ $t('mating.Select_UBN') }}</option>
                    <option v-for="item in ubns" :key="item.id" :value="item.id">
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                    </option>
                </select>
                <span v-if="v$.ubnId.$error" class="text-sm text-danger">
                    {{ v$.ubnId.$errors[0].$message }}
                </span>
            </div>
            <div class="input-group input-group-static null" v-if="userRoleName == 'Keeper'">               
                <label>{{ $t('animal.UBN') }}</label>
                <input :value="localFormData.ubn" type="text" class="form-control form-control-default" disabled>
                <input v-model="localFormData.ubnId" type="hidden">
            </div>
          </div>
        </div>          
      </div>      
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 btn-sm bg-gradient-success null null ms-auto mb-0 js-btn-next" type="button" @click="validateAndNextStep">{{ $t('common.Next') }}</button>        
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { computed, reactive, watch } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: "AnimalUBN",
  props: {
    formData: Object,
    nextStep: Function,    
    ubns: Array,
    animals: Array,
    emitter: Object
  }, 
  setup(props, { emit }) {
    
    const { t } = useI18n()
        

    const localFormData = reactive({ ...props.formData })

    const rules = computed(() => {
      return {        
        ubnId: {
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('common.Select_a_ubn'), value => value !== '')
        }
      };
    });
    
    const v$ = useVuelidate(rules, localFormData)
    
    watch(
      () => props.formData.ubn,
      (newVal) => {
        localFormData.ubn = newVal;
      }
    );

    watch(
      () => props.formData.ubnId,
      (newVal) => {
        localFormData.ubnId = newVal;
      },
      { immediate: true }
    );

    watch(localFormData, () => {
      emit('update:formData', localFormData)
    }, { deep: true })

    const validateAndNextStep = async () => {
      v$.value.$touch()
      if (v$.value.$pending) {
        await v$.value.$validate()
      }

      if (!v$.value.$invalid) {
        // Emit validated values to parent
        emit('request-animals', {
          associationId: localFormData.associationId,
          ubnId: localFormData.ubnId
        })
      }
    }

    return {
      localFormData,      
      v$,
      validateAndNextStep
    }
  },
  components: {
  },
  computed: {
      userRoleName() {
          return this.$store.state.user?.roleName;
      }      
  },
  methods: {
  }
}
</script>